import type { ReactNode } from 'react'
import { Link } from '@inertiajs/react'
import { tabsListVariants, tabsTriggerVariants } from '@/components/ui/Tabs'
import { cn } from '@/lib/utils'
import type { PricingChannel } from '../pricingTypes'

interface Props {
  channels: PricingChannel[]
  activeSlug: string
  // The page URL for a channel — show and edit pages link to themselves.
  hrefFor: (channelSlug: string) => string
  // Right-aligned control inside the tab bar (edit page: Manage Price Levels).
  trailing?: ReactNode
}

// Sale-channel tabs on top of the pricing table. URL-driven, so a channel
// switch is a plain Inertia visit that keeps the scroll position.
export default function PricingChannelTabs({ channels, activeSlug, hrefFor, trailing }: Props) {
  return (
    <nav
      aria-label="Sale channel"
      className={cn(tabsListVariants({ variant: 'nav' }), 'flex w-full overflow-x-auto overflow-y-hidden px-2')}
    >
      {channels.map((ch) => {
        const active = ch.slug === activeSlug
        return (
          <Link
            key={ch.id}
            href={hrefFor(ch.slug)}
            preserveScroll
            aria-current={active ? 'page' : undefined}
            data-state={active ? 'active' : 'inactive'}
            className={cn(tabsTriggerVariants({ variant: 'nav' }), 'mb-0')}
          >
            {ch.name}
          </Link>
        )
      })}
      {trailing}
    </nav>
  )
}
